
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ConsumableReservationId, ConsumableId, FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { ConsumableDetailReservationDto_$reflection, ConsumableDetailDto_$reflection } from "../../Shared/Consumable.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { deleteConsumableReservation } from "../../Requests/Consumable.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ConsumableReservationDeleted", "DeleteReservation", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Consumables.Dialogs.DeleteReservationDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", class_type("System.Exception")]]]);
}

export class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, Consumable, ConsumableReservation) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Consumable = Consumable;
        this.ConsumableReservation = ConsumableReservation;
    }
}

export function State_$reflection() {
    return record_type("Consumables.Dialogs.DeleteReservationDialog.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Consumable", ConsumableDetailDto_$reflection()], ["ConsumableReservation", ConsumableDetailReservationDto_$reflection()]]);
}

function init(successCallback, onClose, consumable, consumableReservation) {
    return [new State(FormState_get_empty(), successCallback, onClose, consumable, consumableReservation), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 0: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.OnClose, state.Consumable, state.ConsumableReservation), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Consumable, state.ConsumableReservation), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("tool.dialog_remove_reservation_success")]))];
            }
        }
        case 2:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Consumable, state.ConsumableReservation), Cmd_none()];
        default:
            return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Consumable, state.ConsumableReservation), deleteConsumableReservation(new ConsumableId(parse(state.Consumable.Id)), new ConsumableReservationId(parse(state.ConsumableReservation.Id)), (Item_1) => (new Msg(0, [Item_1])), (Item_2) => (new Msg(2, [Item_2])))];
    }
}

export function DeleteConsumableReservationDialog(props) {
    let Title;
    const matchValue = props.Reservation;
    if (matchValue != null) {
        const reservation = matchValue;
        const t = useTranslation()[0];
        const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.Consumable, reservation), update, (_arg_1, _arg_1_1) => {
        }), undefined, [props.IsOpen]);
        return createElement(ConfirmationDialog, (Title = t("general.delete"), {
            Description: t("tool.dialog_remove_reservation_query"),
            IsOpen: props.IsOpen,
            OnClose: props.OnClose,
            OnConfirm: patternInput_1[0].FormState.IsLoading ? (() => {
            }) : (() => {
                patternInput_1[1](new Msg(1, []));
            }),
            Title: Title,
        }));
    }
    else {
        return defaultOf();
    }
}

